module.exports = __webpack_public_path__ + "static/media/Detectives_ID.d5b4d928.png";